import {
  AfterViewInit,
  Component,
  ContentChildren,
  ElementRef,
  inject,
  Input,
  input,
  output,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ColumnTemplateDirective } from './table-column.directive';

@Component({
  selector: 'shared-table',
  imports: [NgTemplateOutlet],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent<T> implements AfterViewInit {
  readonly title = input<string>('---');
  readonly data = input<T[]>([]);
  readonly columns = input<{ key: string; label: string }[]>([]);
  readonly sortable = input<boolean>(false);

  sortColumn = [null, null] as [string | null, 'asc' | 'desc' | null];
  sortColumnChange = output<[string | null, 'asc' | 'desc' | null]>();

  @ContentChildren(ColumnTemplateDirective)
  templates!: QueryList<ColumnTemplateDirective>;

  ngOnInit() {}

  ngAfterViewInit(): void {}

  getTemplate(columnName: string): TemplateRef<any> | undefined {
    return this.templates.find(t => t.columnKey === columnName)?.templateRef;
  }

  toggleSorting(columnKey: string) {
    if (!this.sortable()) {
      return;
    }
    if (this.sortColumn[0] === columnKey) {
      switch (this.sortColumn[1]) {
        case null:
          this.sortColumn = [columnKey, 'asc'];
          break;
        case 'asc':
          this.sortColumn = [columnKey, 'desc'];
          break;
        case 'desc':
          this.sortColumn = [null, null];
          break;
        default:
          break;
      }
    } else {
      this.sortColumn = [columnKey, 'asc'];
    }

    this.sortColumnChange.emit(this.sortColumn);
  }
}
